import { useLanguage } from "@/i18n";
import Reveal from "@/components/Reveal";
import { Flame } from "lucide-react";

const IMG_SKEWERS = "https://images.unsplash.com/photo-1586058584825-c1e87ed735b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxsYXJnZSUyMG91dGRvb3IlMjBiYnElMjBncmlsbCUyMHNtb2tlciUyMG1peGVkJTIwZ3JpbGwlMjBtZWF0JTIwZmVhc3R8ZW58MHx8fHwxNzkyNjk0Mjg2fDA&ixlib=rb-4.1.0&q=85&w=1200";
const IMG_PLATTER = "https://images.unsplash.com/photo-1724598170629-7e264f14f6de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxjdXJhY2FvJTIwYmVhY2glMjBzdW5zZXQlMjB0dXJxdW9pc2UlMjBvY2VhbnxlbnwwfHx8fDE3OTI2OTMxNjJ8MA&ixlib=rb-4.1.0&q=85";

export default function MenuSection() {
  const { t } = useLanguage();
  return (
    <section id="menu" data-testid="menu-section" className="relative py-24 sm:py-32 bg-surface/40 border-y border-stroke/60">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
        <div>
          <Reveal>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-ocean mb-4">{t.menu.kicker}</p>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight mb-3">{t.menu.title}</h2>
            <p className="text-slate-400 text-sm sm:text-base mb-10">{t.menu.sub}</p>
          </Reveal>
          <div className="divide-y divide-stroke/70">
            {t.menu.items.map((item, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <div className="group py-4 flex gap-5 items-baseline hover:pl-2 transition-all duration-300" data-testid={`menu-item-${i}`}>
                  <span className="font-mono text-xs text-sunset shrink-0">{String(i + 1).padStart(2, "0")}</span>
                  <div>
                    <h3 className="font-display font-bold text-base sm:text-lg group-hover:text-sunset transition-colors duration-300 flex items-center gap-2">
                      {item.name}
                      {i === 0 && <Flame size={14} className="text-sunset" />}
                    </h3>
                    <p className="text-sm text-slate-400 mt-0.5">{item.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.1} className="lg:sticky lg:top-24">
          <div className="relative">
            <div className="rounded-3xl overflow-hidden border border-stroke rotate-1 hover:rotate-0 transition-transform duration-700 shadow-[0_30px_80px_rgba(0,0,0,0.5)]">
              <img src={IMG_SKEWERS} alt="BBQ skewers" className="w-full h-[26rem] sm:h-[32rem] object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-night/40 to-transparent" />
            </div>
            <div className="absolute -bottom-6 -left-4 sm:-left-8 w-36 sm:w-48 rounded-2xl overflow-hidden border-2 border-night -rotate-3 shadow-2xl">
              <img src={IMG_PLATTER} alt="BBQ platter" className="w-full h-28 sm:h-36 object-cover" />
            </div>
            <span className="absolute -top-4 -right-3 bg-sunset text-night font-mono text-[11px] font-bold uppercase tracking-widest px-4 py-2 rounded-full rotate-3 shadow-lg">
              All-in · €75
            </span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
